import { SOCKET } from "../reducers/socket";
import { io } from "socket.io-client";

export const openSocket = (id: string) => {
    const socket = io("https://api.100pay.org", {
        transports: ["websocket", "polling", "flashsocket"], 
        // autoConnect: false, 
        query: {
            ownerId: id
        }
    });

    return {
        type: SOCKET.OPEN,
        payload: socket
    }
}

export const closeSocket = () => {
    return {
        type: SOCKET.CLOSE
    }
}